import * as React from "react";
import { useNavigate } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  userName: string;
  role: string | undefined;
  timestamp: string;
  onRefresh: () => void;
}

export function DashboardHead({ userName, role, timestamp, onRefresh }: Props): React.ReactElement {
  const navigate = useNavigate();
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-[28px] font-semibold tracking-tight text-text-primary">
          Visão geral da operação
        </h1>
        <p className="mt-1 text-[13px] text-text-secondary">
          {userName ? `Olá, ${userName}. ` : ""}
          <span className="font-mono text-text-tertiary">Atualizado em {timestamp}</span>
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onRefresh} aria-label="Atualizar dados">
          <RefreshCw className="mr-1 h-3.5 w-3.5" /> Atualizar
        </Button>
        {role === "GESTOR" ? (
          <>
            <Button variant="secondary" size="sm" onClick={() => navigate("/lines")}>
              Gerenciar linhas
            </Button>
            <Button size="sm" onClick={() => navigate("/lines/new")}>
              Nova linha
            </Button>
          </>
        ) : null}
      </div>
    </header>
  );
}
